import { loadStripe } from "@stripe/stripe-js/pure";
// Type-only, so TypeScript erases it and no require of the side-effecting main
// entry survives into the bundle. /pure does not re-export the Stripe type itself.
import type { Stripe } from "@stripe/stripe-js";

// Two separate things caused Stripe.js (~240 KB) to download on every page rather
// than only the ones with a payment form:
//
//   * calling loadStripe at module scope, so it ran as soon as the bundle booted;
//   * importing "@stripe/stripe-js" at all -- its main entry calls loadScript(null)
//     as an import side effect, which defeats any amount of laziness on our side.
//     "@stripe/stripe-js/pure" is the same API without that side effect, and waits
//     to be asked.
//
// So the deferral needs both: the /pure entry point, and a function rather than a
// module-scope constant. The promise is memoised so every call site shares a single
// Stripe instance.
let stripePromise: Promise<Stripe | null> = null;

export const getStripe = (): Promise<Stripe | null> => {
  if (!stripePromise) {
    stripePromise = loadStripe(process.env.STRIPE_PUBLISHABLE_KEY);
  }

  return stripePromise;
};
